import { render, staticRenderFns } from "./WebList.vue?vue&type=template&id=e323f7c2&scoped=true"
import script from "./WebList.vue?vue&type=script&lang=js"
export * from "./WebList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e323f7c2",
  null
  
)

export default component.exports